import React, { useMemo, useState } from "react";

const videos = [
  {
    id: "fb-video-1",
    src: "https://www.facebook.com/plugins/video.php?height=476&href=https%3A%2F%2Fwww.facebook.com%2Freel%2F921733107387515%2F&show_text=true&width=268&t=0",
  },
  {
    id: "fb-video-2",
    src: "https://www.facebook.com/plugins/video.php?height=476&href=https%3A%2F%2Fwww.facebook.com%2Freel%2F1911185423090183%2F&show_text=true&width=267&t=0",
  },
  {
    id: "fb-video-3",
    src: "https://www.facebook.com/plugins/video.php?height=476&href=https%3A%2F%2Fwww.facebook.com%2FAsherJewelsPH%2Fvideos%2F1426545405722111%2F&show_text=true&width=268&t=0",
  },
  {
    id: "fb-video-4",
    src: "https://www.facebook.com/plugins/video.php?height=476&href=https%3A%2F%2Fwww.facebook.com%2FAsherJewelsPH%2Fvideos%2F2401302613651611%2F&show_text=true&width=267&t=0",
  },
  {
    id: "fb-video-5",
    src: "https://www.facebook.com/plugins/video.php?height=476&href=https%3A%2F%2Fwww.facebook.com%2FAsherJewelsPH%2Fvideos%2F1386412469413389%2F&show_text=true&width=357&t=0",
  },
];

export default function FacebookVideoSection() {
  const [activeVideo, setActiveVideo] = useState(null);
  const activeVideoData = useMemo(
    () => videos.find((video) => video.id === activeVideo) || null,
    [activeVideo]
  );

  return (
    <section className="facebook-video-section">
      <div className="facebook-video-section__inner">
        <div className="facebook-video-section__heading">
          <p className="facebook-video-section__eyebrow">From Our Facebook Page</p>
          <h2>Watch Our Latest Gold Highlights</h2>
          <p>
            Spend a little time with our newest featured pieces, short showcases,
            and fresh jewelry stories from Asher Jewels.
          </p>
        </div>

        <div className="facebook-video-grid facebook-video-grid--desktop">
          {videos.map((video, index) => (
            <article key={video.id} className="facebook-video-card">
              <div className="facebook-video-card__frame">
                <iframe
                  title={`Asher Jewels Facebook Video ${index + 1}`}
                  src={video.src}
                  width="100%"
                  height="100%"
                  style={{ border: "none", overflow: "hidden" }}
                  scrolling="no"
                  frameBorder="0"
                  allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                  allowFullScreen
                  loading="lazy"
                />
              </div>
            </article>
          ))}
        </div>

        <div className="facebook-video-carousel" aria-label="Facebook video highlights">
          {videos.map((video, index) => (
            <button
              key={video.id}
              type="button"
              className="facebook-video-thumb"
              onClick={() => setActiveVideo(video.id)}
            >
              <span className="facebook-video-thumb__preview" aria-hidden="true">
                <iframe
                  title={`Asher Jewels Facebook Video Preview ${index + 1}`}
                  src={video.src}
                  width="100%"
                  height="100%"
                  style={{ border: "none", overflow: "hidden" }}
                  scrolling="no"
                  frameBorder="0"
                  loading="lazy"
                  tabIndex="-1"
                />
                <span className="facebook-video-thumb__overlay">
                  <span className="facebook-video-thumb__badge">Facebook Video</span>
                  <span className="facebook-video-thumb__play" aria-hidden="true">
                    &#9654;
                  </span>
                </span>
              </span>
              <span className="facebook-video-thumb__title">Gold Highlight {index + 1}</span>
              <span className="facebook-video-thumb__meta">Tap to expand and play</span>
            </button>
          ))}
        </div>
      </div>

      {activeVideoData ? (
        <div
          className="facebook-video-modal"
          role="dialog"
          aria-modal="true"
          aria-label="Facebook video player"
          onClick={() => setActiveVideo(null)}
        >
          <div
            className="facebook-video-modal__dialog"
            onClick={(event) => event.stopPropagation()}
          >
            <button
              type="button"
              className="facebook-video-modal__close"
              onClick={() => setActiveVideo(null)}
              aria-label="Close video"
            >
              &times;
            </button>
            <div className="facebook-video-modal__frame">
              <iframe
                title="Asher Jewels Facebook Video"
                src={activeVideoData.src}
                width="100%"
                height="100%"
                style={{ border: "none", overflow: "hidden" }}
                scrolling="no"
                frameBorder="0"
                allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                allowFullScreen
              />
            </div>
          </div>
        </div>
      ) : null}
    </section>
  );
}
